// register vue composition api globally
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import App from './App.vue';
import Toast, { POSITION } from 'vue-toastification';

import 'vue-toastification/dist/index.css';
import './styles/main.scss';
import './styles/tailwind.css';

// Vuetify
import { registerPlugins } from '@/plugins';

// Create app
const app = createApp(App);

// Set up website head
const head = createHead();

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/big-board', name: 'Big Board', component: () => import('@/views/BigBoard.vue') },
  { path: '/matrix', name: 'Draft Matrix', component: () => import('@/views/DraftMatrix.vue') },
  { path: '/stats', name: 'Stats', component: () => import('@/views/QueryTool.vue'), props: true },
  { path: '/players/:id', name: 'Players', component: () => import('@/views/PlayerStats.vue'), props: true },
  { path: '/glossary', name: 'Glossary', component: () => import('@/views/Glossary.vue') },
  { path: '/scouts', name: 'Scouts', component: () => import('@/views/Scouts.vue') },
  { path: '/terms', name: 'Terms', component: import('@/views/Terms.vue') },
  { path: '/privacy', name: 'Privacy', component: import('@/views/Privacy.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/home' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const pinia = createPinia();

app.use(pinia).use(head).use(router);
app.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  position: POSITION.BOTTOM_CENTER,
  timeout: 3000,
});
registerPlugins(app);

// Mount app
app.mount('#sis-nfl-draft');
